/* eslint react/prop-types: 0 */

import React, { Component } from "react";
import { connect } from "react-redux";
import { Icon, Input, Select } from "semantic-ui-react";
import { Button, Modal, ModalHeader, ModalBody, Form } from "reactstrap";
import { TableComp } from "../component/TableComp";
import { HeaderComp } from "./Perusahaan/HeaderComp";
import {
  postDataAction,
  getDataAction,
  editDataAction,
  softDeleteDataAction,
} from "../config/redux/action";
import LoadingTop from "../component/LoadingTop";

class Perusahaan extends Component {
  constructor() {
    super();
    this.state = {
      modalEdit: false,
      modalDelete: false,
      ActiveItemModalEdit: "Induk",
      ValueShowData: 10,
      ValuePage: 0,
      searchName: "",
      typingTimeout: 0,
      dataSelected: {},
    };
  }
  componentDidMount() {
    this.getData();
  }

  getData = () => {
    this.getDataTable(10, 0);
  };

  getDataTable = () => {
    const { ValueShowData, ValuePage, searchName } = this.state;
    this.props
      .getData({
        path: `perusahaan?search=nama:*${searchName}*&size=${ValueShowData}&page=${ValuePage}`,
        type: "GET_DATA_TABLE_PERUSAHAAN",
      })
      .then(() => {
        console.log(this.props.dataTable);
      });
  };

  handleSearch = (event) => {
    this.setState(
      {
        searchName: event.target.value,
      },
      () => {
        if (this.state.typingTimeout) {
          clearTimeout(this.state.typingTimeout);
        }

        this.setState({
          typingTimeout: setTimeout(() => {
            this.getDataTable();
          }, 1000),
        });
      }
    );
  };

  handlePagginateTable = (ValueShowData, ValuePage) => {
    this.setState(
      {
        ValueShowData: ValueShowData,
        ValuePage: ValuePage - 1,
      },
      () => {
        this.getDataTable();
      }
    );
  };

  getDataPerusahaan = (ValuePage, search) => {
    this.props.getData({
      path: `perusahaan?sort=nama,ASC&page=${ValuePage}&size=10`,
      type: "GET_DATA_PERUSAHAAN",
    });
  };

  postDataPerusahaan = (data) => {
    this.props.postData(data).then(() => {
      this.getData();
    });
  };

  handleModalDelete = () => {
    this.setState((prevState) => ({
      modalDelete: !prevState.modalDelete,
    }));
  };

  handleModalEdit = () => {
    this.setState((prevState) => ({
      modalEdit: !prevState.modalEdit,
    }));
  };

  handleAction = (row, type) => {
    this.setState({
      dataSelected: row,
    });
    type === "edit" ? this.handleModalEdit() : this.handleModalDelete();
  };

  handleChangeEdit = (event) => {
    const { name, value } = event.target;
    this.setState({
      dataSelected: {
        ...this.state.dataSelected,
        [name]: value,
      },
    });
  };

  handleSubmitEdit = (e) => {
    e.preventDefault();
    this.props
      .editData({
        dispatch: "",
        title: "Perusahaan",
        path: "perusahaan",
        body: this.state.dataSelected,
      })
      .then(() => {
        this.handleModalEdit();
        this.getData();
      });
  };

  handleSubmitDelete = (e) => {
    e.preventDefault();
    this.props
      .softDeleteDataAction({
        dispatch: "",
        title: "Perusahaan",
        path: `perusahaan/soft-delete`,
        body: {
          ...this.state.dataSelected,
          softDeleted: true
        },
      })
      .then(() => {
        this.handleModalDelete();
        this.getData();
      });
  };

  handleMenuModal = (e, { name }) =>
    this.setState({ ActiveItemModalEdit: name });

  formatterAction = (cell, row) => {
    const { user } = this.props;
    return (
      <span>
        {user.role < 4 && (
          <>
            <label
              className="text-decoration-none text-dark btn-action bg-white mr-2"
              onClick={() => this.handleAction(row, "edit")}
            >
              <Icon name="pencil" />
            </label>
            {user.role === 1 && <label
              className="text-decoration-none text-dark btn-action bg-white"
              onClick={() => this.handleAction(row, "delete")}
            >
              <Icon name="trash alternate outline" color="red" />
            </label>}

          </>
        )}
      </span>
    );
  };

  render() {
    const { dataSelected } = this.state;

    const columns = [
      {
        dataField: "nama",
        text: "Nama Perusahaan",
        headerStyle: () => ({ width: "40%", textAlign: "left" }),
      },
      {
        dataField: "induk.nama",
        text: "Induk",
      },
      {
        dataField: "kategori",
        text: "Jenis Perusahaan",
        formatter: (cell, row) => {
          return (
            <p>{cell === 1 ? "Lembaga Keuangan" : "Non Lembaga Keuangan"}</p>
          );
        },
      },
      {
        dataField: "",
        text: "",
        align: "right",
        formatter: this.formatterAction,
      },
    ];

    return (
      <>
        <HeaderComp
          getDataPerusahaan={this.getDataPerusahaan}
          postData={this.postDataPerusahaan}
          listPerusahaan={this.props.listPerusahaan || []}
        />
        <LoadingTop />
        <div className="container mt-3">
          <div className="row">
            <div className="col-md-12">
              <div className="card container shadow-sm py-3 border-0">
                <Input
                  onKeyUp={this.handleSearch}
                  icon
                  iconPosition="left"
                  className="w-50 my-3"
                  placeholder="Cari Nama Perusahaan"
                >
                  <input />
                  <Icon name="search" />
                </Input>
                <TableComp
                  data={this.props.dataTable || []}
                  columns={columns}
                  getDataTable={this.handlePagginateTable}
                />
              </div>
            </div>
          </div>
          <Modal isOpen={this.state.modalEdit} toggle={this.handleModalEdit}>
            <ModalHeader toggle={this.handleModalEdit}>
              Edit Perusahaan
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={this.handleSubmitEdit}>
                <div className="container">
                  <Input
                    value={dataSelected.nama}
                    className="mb-3 w-100"
                    type="name"
                    name="nama"
                    placeholder="Nama Perusahaan"
                    onChange={this.handleChangeEdit}
                    required
                  />{" "}
                  <br />
                  <Select
                    className="mb-3 w-100"
                    placeholder="Jenis Perusahaan"
                    name="kategori"
                    value={dataSelected.kategori}
                    onChange={(e, { name, value }) =>
                      this.handleChangeEdit({
                        target: { name: name, value: value },
                      })
                    }
                    options={[
                      { value: 1, text: "Lembaga Keuangan" },
                      { value: 2, text: "Non Lembaga Keuangan" },
                    ]}
                    required
                  />
                </div>
                <Button color="primary" className="mt-4" block>
                  Simpan
                </Button>{" "}
                <Button color="secondary" onClick={this.handleModalEdit} block>
                  Cancel
                </Button>
              </Form>
            </ModalBody>
          </Modal>
          <Modal
            isOpen={this.state.modalDelete}
            toggle={this.handleModalDelete}
          >
            <ModalBody className="text-center my-3">
              <Icon color="red" name="trash alternate outline" size="large" />
              <h3>Delete Perusahaan</h3>
              <p>
                Apakah Anda yakin akan menghapus perusahaan{" "}
                <span className="font-weight-bold">{dataSelected.nama}</span> ?
                <br />
                Proses ini tidak dapat diurungkan.
              </p>
              <div>
                <Button className="mr-3" onClick={this.handleModalDelete}>
                  Cancel
                </Button>
                <Button color="danger" onClick={this.handleSubmitDelete}>
                  Delete
                </Button>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </>
    );
  }
}

const reduxState = (state) => {
  return {
    user: state.main.dataUser,
    listPerusahaan: state.perusahaanReducer.listPerusahaan,
    totalPages: state.perusahaanReducer.totalPages,
    dataTable: state.perusahaanReducer.dataTablePerusahaan,
  };
};

const reduxDispatch = (dispatch) => ({
  editData: (data) => dispatch(editDataAction(data)),
  softDeleteDataAction: (data) => dispatch(softDeleteDataAction(data)),
  postData: (data) => dispatch(postDataAction(data)),
  getData: (data) => dispatch(getDataAction(data)),
});

export default connect(reduxState, reduxDispatch)(Perusahaan);
